import {
  EmptyStateNoResultIllustration,
  EmptyStateProps,
} from '@ardoq/status-ui';
import { OnButtonClick } from './types';
import { PrimaryButton } from '@ardoq/button';
import { t, type I18nLocale } from '@ardoq/i18n';

type DataFilteredArgs = {
  editDataset: OnButtonClick;
  showActionControls?: boolean;
  i18nLocale: I18nLocale;
};

export const dataFiltered = ({
  editDataset,
  showActionControls = true,
  i18nLocale,
}: DataFilteredArgs): EmptyStateProps => ({
  media: <EmptyStateNoResultIllustration />,
  title: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.dataFiltered.title',
    'There is no data to show'
  ),
  description: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.dataFiltered.description',
    'Try editing your dataset, check the filters and any other selections'
  ),
  children: !showActionControls ? null : (
    <PrimaryButton onClick={editDataset}>
      {t(
        i18nLocale,
        'tabview:graphViews.emptyStateLayout.dataFiltered.editDataset',
        'Edit dataset'
      )}
    </PrimaryButton>
  ),
});
